export default {"src":"/_next/static/media/pasl.0de43585.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};